<!-- src/app/components/countdown/countdown.component.html -->
<div class="countdown" [class]="'countdown--' + theme">
  <div class="countdown__label">{{ label }}</div>
  <div *ngIf="!expired" class="countdown__units">
    <div class="countdown__unit">
      <span class="countdown__num">{{ timeLeft.days }}</span>
      <span class="countdown__sub">Days</span>
    </div>
    <span class="countdown__sep">:</span>
    <div class="countdown__unit">
      <span class="countdown__num">{{ pad(timeLeft.hours) }}</span>
      <span class="countdown__sub">Hours</span>
    </div>
    <span class="countdown__sep">:</span>
    <div class="countdown__unit">
      <span class="countdown__num">{{ pad(timeLeft.minutes) }}</span>
      <span class="countdown__sub">Min</span>
    </div>
    <span class="countdown__sep">:</span>
    <div class="countdown__unit">
      <span class="countdown__num">{{ pad(timeLeft.seconds) }}</span>
      <span class="countdown__sub">Sec</span>
    </div>
  </div>
  <div *ngIf="expired" class="countdown__expired">Date has passed</div>
</div>
